import gql from 'graphql-tag';

export const GET_SEAT_LEGACY = gql`
  query SeatLegacy($id: ID!) {
    seatLegacy(id: $id) {
      altId
      externalSeatId
      id
      name
      status
      dsp {
        id
        name
        status
        territories
      }
      territories
    }
  }
`;

export const GENERATE_UNIQUE_EXTERNAL_ID = gql`
  query GenerateUniqueExternalId {
    generateUniqueExternalId
  }
`;
